import * as React from "react";
import C from "classnames";
export const AlertHeading = (props) => {
    return (React.createElement("h4", { className: C(props.className, "alert-heading"), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=AlertHeading.js.map